import { http } from "../../../axios";

class authService {
  register(data: any) {
    return http().post(`auth/register`, data);
  }
  registerOtp(payload:any){
    return http().post(`auth/verify_otp`,payload);
  }
  emailValidation(payload:any){
    return http().post(`auth/email_validation`,payload);
  }
  login(data: any) {
    return http().post(`auth/login`, data);
  }

  forgotPassword(payload:any){
    return http().post(`auth/forgot_password`,payload);
  }
  emailVerifyOtp(payload:any){
    return http().post(`auth/email/verify`,payload);
  }

  resetPassword(payload:any){
    return http().post(`auth/reset_password`,payload);
  }

  getImages(){
    return http().get(`file/images`);
  }

}

export default new authService();
